import React, { Component } from "react";
import { connect } from "react-redux";
import { Select, Button } from "antd";
import _ from "i18n";
import { ERP_MODELS } from "Config";
import { setSourceModel } from "Actions";
import styles from "./TimeSheetUploadContent.local.scss";
import { SvgIcon, ICONS } from "../Common/Icons";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";
import DocumentUploader from "../Common/DocumentUploader/DocumentUploader";

const { Option } = Select;

class TimeSheetUploadContent extends Component {
  // **** TimeSheetUploadContent (functions) ***** //
  constructor(props) {
    super(props);
    this.state = {
      ERP: Object.keys(ERP_MODELS)[0]
    };
  }

  initModelConfig = sourceModel => {
    if (!sourceModel) {
      const { ERP } = this.state;
      this.props.dispatch(setSourceModel(ERP));
    }
  };

  handleERPChange = value => {
    this.setState({
      ERP: value
    });
    this.props.dispatch(setSourceModel(value));
  };

  render() {
    const { ERP } = this.state;
    const { sourceModel, attachment } = this.props;

    this.initModelConfig(sourceModel);

    return (
      <div className="tamtam-modal upload-modal upload-modal__body">
        <ModalCloseButton onClose={this.props.onCancel} />
        <div className="upload-modal__content">
          <div className="upload-modal__header small-12">
            <div className="upload-modal__header-icon">
              <SvgIcon icon={ICONS.UPLOAD} />
            </div>
            <div className="upload-modal__header-title">
              {_("Importer un emploi du temps")}
            </div>
          </div>
          <div
            className="row"
            style={{
              background: "#F1F2F4",
              padding: "2rem 1rem 1rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "left"
            }}
          >
            <span className={`columns medium-6 ${styles.select_label}`}>
              Choisissez un modele :
            </span>
            <span className={`columns medium-6 ${styles.select_span}`}>
              <Select
                defaultValue={ERP}
                style={{ width: 300 }}
                onChange={this.handleERPChange}
              >
                {Object.keys(ERP_MODELS).map((item, i) => {
                  return (
                    <Option value={item} key={i}>
                      {item}
                    </Option>
                  );
                })}
              </Select>
            </span>
            <span className={`columns medium-12`}>
              <div className={styles.model_description}>
                {_("contentModelDescription")}
              </div>
            </span>
            <span className={"columns medium-12"}>
              <DocumentUploader attachment={attachment} />
            </span>
            <div className={`columns medium-12 ${styles.modal_footer}`}>
              <Button
                key="cancel"
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: 14,
                  height: 35,
                  marginRight: 5,
                  padding: "4px 19px",
                  background: "transparent",
                  color: "#6D7F92",
                  boxSizing: "border-box",
                  textTransform: "uppercase",
                  border: "1px solid rgba(109, 127, 146, 0.7)"
                }}
                onClick={this.props.onCancel}
              >
                {_("cancel")}
              </Button>
              <Button
                type={"success"}
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: 14,
                  height: 37,
                  marginRight: 5,
                  padding: "4px 30px",
                  background: "#0EBF9E",
                  textTransform: "uppercase",
                  color: "white"
                }}
                disabled={!this.props.attachment}
                loading={this.props.loading}
                onClick={this.props.onSave}
              >
                {_("save")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  attachment: state.timeSheet.timeSheetAttachment,
  sourceModel: state.timeSheet.sourceModel
});

export default connect(mapStateToProps)(TimeSheetUploadContent);



// WEBPACK FOOTER //
// ./src/components/TimeSheetUpload/TimeSheetUploadContent.js